import SettingsIntegrationsClient from './settingsIntegrations.client'

export default class SettingIntegrationsService {
  constructor() {
    this.client = new SettingsIntegrationsClient()
  }

  async getSettingIntegrations() {
    try {
      return await this.client.getBlingAuthGetCode()
    } catch (error) {
      console.log(error)
    }
  }

  async getSettingIntegrationsBling() {
    try {
      return await this.client.getBlingAuthGetCode()
    } catch (error) {
      console.log(error)
    }
  }

  async getIntegrationsVerifyByNome(nome) {
    try {
      const { valid } = await this.client.getIntegrationsVerifyByNome(nome)
      return valid
    } catch (error) {
      console.log(error)
    }
  }
}
